export default "__VITE_ASSET__DId75QP8__"